<ng-container *ngTemplateOutlet="isSortable() ? sortable : nonSortable" />

<ng-template #nonSortable>
  <span class="td-wb-table__header__content">
     <ng-container *ngTemplateOutlet="content" />
  </span>
</ng-template>

<ng-template #sortable>
  <span class="td-wb-table-header__container"
        tabindex="0"
        role="button"
        (click)="onClick($event)"
        (keydown.space)="onClick($event)"
        (keydown.enter)="onClick($event)">
    <td-wb-sort-icon class="td-wb-table-header__sort-icon" />
    <span #container
          class="td-wb-table__header__content td-wb-table__header__content--with-sort">
      <ng-container *ngTemplateOutlet="content" />
    </span>
    <span class="td-wb-vh">{{ 'tdWb.tableHeader.' + ariaSort | tdWbTranslate }}</span>
  </span>
</ng-template>

<ng-template #content><ng-content /></ng-template>
